import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Ship, School, FileText, Anchor, Star, Phone, Upload, Send, Loader2 } from 'lucide-react';
import SuccessModal from '@/components/SuccessModal';

const AtendimentoVip: React.FC = () => {
  const [serviceType, setServiceType] = useState<string | null>(null);
  const [priority, setPriority] = useState<string>("Normal");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(e.currentTarget);
    
    try {
      const response = await fetch("https://formsubmit.co/ajax/jldespachantenautico@gmail.com", {
        method: "POST",
        body: formData
      });

      if (response.ok) {
        setShowSuccess(true);
      } else {
        alert("Ocorreu um erro ao enviar. Por favor, tente novamente.");
      }
    } catch (error) {
      console.error("Erro no envio:", error);
      alert("Erro de conexão. Verifique sua internet.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderServiceSubOptions = () => {
    switch (serviceType) {
      case 'Escola Náutica':
        return (
          <div className="space-y-3 p-4 rounded-lg bg-white/5 border border-white/10 animate-in fade-in slide-in-from-top-2">
            <label className="text-sm font-medium text-gold">Qual habilitação você tem interesse?</label>
            <select name="Habilitação de Interesse" className="w-full h-11 rounded-md border border-white/10 bg-navy-deep px-3 py-2 text-sm text-primary-foreground focus:outline-none focus:ring-1 focus:ring-gold appearance-none bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23D4AF37%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')] bg-[length:12px_12px] bg-[right_1rem_center] bg-no-repeat">
              <option value="Arrais Amador" className="bg-navy-deep text-white">Arrais Amador</option>
              <option value="Motonauta" className="bg-navy-deep text-white">Motonauta</option>
              <option value="Mestre Amador" className="bg-navy-deep text-white">Mestre Amador</option>
              <option value="Arrais + Motonauta" className="bg-navy-deep text-white">Combo: Arrais + Motonauta</option>
            </select>
          </div>
        );
      case 'Despachante Náutico':
        return (
          <div className="space-y-3 p-4 rounded-lg bg-white/5 border border-white/10 animate-in fade-in slide-in-from-top-2">
            <label className="text-sm font-medium text-gold">Qual serviço documental?</label>
            <select name="Serviço Despachante" className="w-full h-11 rounded-md border border-white/10 bg-navy-deep px-3 py-2 text-sm text-primary-foreground focus:outline-none focus:ring-1 focus:ring-gold appearance-none bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23D4AF37%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')] bg-[length:12px_12px] bg-[right_1rem_center] bg-no-repeat">
              <option value="Transferência de Propriedade" className="bg-navy-deep text-white">Transferência de Propriedade</option>
              <option value="Renovação de TIE" className="bg-navy-deep text-white">Renovação de TIE/TIEM</option>
              <option value="Inscrição de Embarcação" className="bg-navy-deep text-white">Inscrição de Embarcação Nova</option>
              <option value="Segunda Via" className="bg-navy-deep text-white">Segunda Via de Documentos</option>
              <option value="Outros" className="bg-navy-deep text-white">Outros</option>
            </select>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Header />
      <div className="relative bg-primary min-h-screen text-primary-foreground pt-32 pb-24">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl text-gold">Portal de Atendimento VIP</h1>
            <p className="mt-4 text-lg text-primary-foreground/70 max-w-2xl mx-auto">
              Preencha os campos abaixo para receber uma proposta detalhada e alinhada às suas necessidades.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Form Section (Left) */}
            <form onSubmit={handleSubmit} className="lg:col-span-2 space-y-10 p-10 rounded-2xl bg-navy-deep/40 backdrop-blur-xl border border-white/10 shadow-2xl">
              <input type="hidden" name="_subject" value="Novo Lead VIP - Site JL Escola Náutica" />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="Tipo de Serviço" value={serviceType || ""} />
              <input type="hidden" name="Prioridade" value={priority} />
              <input type="hidden" name="_cc" value="lucasdasilvamaximorosa@gmail.com,vinitietjen@gmail.com,souzasandro19701@gmail.com,irushlab@gmail.com" />

              <div className="space-y-6">
                <h3 className="font-heading text-2xl text-gold border-b border-gold/20 pb-2">1. Dados Pessoais</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <label htmlFor="name" className="block text-[10px] font-bold mb-2 text-gold uppercase tracking-widest">Nome Completo</label>
                    <Input id="name" name="Nome" placeholder="Seu nome completo" required className="h-12 bg-white/5 border-white/10 focus:border-gold/50 placeholder:text-white/20" />
                  </div>
                  <div>
                    <label htmlFor="whatsapp" className="block text-[10px] font-bold mb-2 text-gold uppercase tracking-widest">WhatsApp</label>
                    <Input id="whatsapp" name="WhatsApp" placeholder="(47) 99999-9999" required className="h-12 bg-white/5 border-white/10 focus:border-gold/50 placeholder:text-white/20" />
                  </div>
                </div>
              </div>
              
              <div className="space-y-8">
                <h3 className="font-heading text-2xl text-gold border-b border-gold/20 pb-2">2. Escopo do Atendimento</h3>
                
                <div className="space-y-3">
                  <label className="block text-[10px] font-bold text-gold uppercase tracking-widest">Unidade de Preferência</label>
                  <select 
                    name="Unidade" 
                    className="w-full h-12 rounded-md border border-white/20 bg-navy-deep px-4 py-2 text-sm text-primary-foreground focus:outline-none focus:ring-1 focus:ring-gold appearance-none bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23D4AF37%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')] bg-[length:14px_14px] bg-[right_1.2rem_center] bg-no-repeat"
                    required
                  >
                    <option value="" disabled selected className="bg-navy-deep text-white/50">Selecione uma unidade...</option>
                    <option value="Balneário Camboriú" className="bg-navy-deep text-white py-2">Balneário Camboriú - SC</option>
                    <option value="São Francisco do Sul" className="bg-navy-deep text-white py-2">São Francisco do Sul - SC</option>
                    <option value="Barra do Sul" className="bg-navy-deep text-white py-2">Barra do Sul - SC</option>
                    <option value="Canoinhas" className="bg-navy-deep text-white py-2">Canoinhas - SC</option>
                  </select>
                </div>

                <div className="space-y-4">
                  <label className="block text-[10px] font-bold text-gold uppercase tracking-widest">Tipo de Serviço</label>
                  <ToggleGroup 
                    type="single" 
                    onValueChange={(v) => v && setServiceType(v)} 
                    className="grid grid-cols-1 md:grid-cols-3 gap-4 h-auto"
                  >
                    <ToggleGroupItem value="Escola Náutica" className="h-24 flex flex-col gap-2 border-white/10 data-[state=on]:bg-gold/10 data-[state=on]:border-gold data-[state=on]:text-gold hover:bg-white/5 transition-all">
                      <School className="w-6 h-6" />
                      <span className="text-xs font-bold uppercase tracking-widest">Escola</span>
                    </ToggleGroupItem>
                    <ToggleGroupItem value="Despachante Náutico" className="h-24 flex flex-col gap-2 border-white/10 data-[state=on]:bg-gold/10 data-[state=on]:border-gold data-[state=on]:text-gold hover:bg-white/5 transition-all">
                      <Ship className="w-6 h-6" />
                      <span className="text-xs font-bold uppercase tracking-widest">Despachante</span>
                    </ToggleGroupItem>
                    <ToggleGroupItem value="Outros Serviços" className="h-24 flex flex-col gap-2 border-white/10 data-[state=on]:bg-gold/10 data-[state=on]:border-gold data-[state=on]:text-gold hover:bg-white/5 transition-all">
                      <FileText className="w-6 h-6" />
                      <span className="text-xs font-bold uppercase tracking-widest">Outros</span>
                    </ToggleGroupItem>
                  </ToggleGroup>
                </div>

                {renderServiceSubOptions()}

                <div className="space-y-4">
                  <label className="block text-[10px] font-bold text-gold uppercase tracking-widest">Prioridade de Manobra</label>
                  <ToggleGroup 
                    type="single" 
                    defaultValue="Normal"
                    onValueChange={(v) => v && setPriority(v)} 
                    className="grid grid-cols-1 md:grid-cols-3 gap-4 h-auto"
                  >
                    <ToggleGroupItem value="Normal" className="h-20 flex flex-col gap-1 border-white/10 data-[state=on]:bg-gold/10 data-[state=on]:border-gold data-[state=on]:text-gold hover:bg-white/5 transition-all">
                      <Anchor className="w-5 h-5" />
                      <span className="text-[10px] font-bold uppercase tracking-tighter">Rotina / Breve</span>
                    </ToggleGroupItem>
                    <ToggleGroupItem value="Alta" className="h-20 flex flex-col gap-1 border-white/10 data-[state=on]:bg-gold/10 data-[state=on]:border-gold data-[state=on]:text-gold hover:bg-white/5 transition-all">
                      <Star className="w-5 h-5" />
                      <span className="text-[10px] font-bold uppercase tracking-tighter">Alta / Urgência</span>
                    </ToggleGroupItem>
                    <ToggleGroupItem value="Urgente" className="h-20 flex flex-col gap-1 border-white/10 data-[state=on]:bg-gold/10 data-[state=on]:border-gold data-[state=on]:text-gold hover:bg-white/5 transition-all">
                      <Phone className="w-5 h-5" />
                      <span className="text-[10px] font-bold uppercase tracking-tighter">Emergência / Imediato</span>
                    </ToggleGroupItem>
                  </ToggleGroup>
                </div>

                <div className="space-y-3">
                  <label htmlFor="document-upload" className="block text-[10px] font-bold text-gold uppercase tracking-widest">Anexar Documentos (Opcional)</label>
                  <div className="flex items-center justify-center w-full">
                    <label htmlFor="document-upload" className="flex flex-col items-center justify-center w-full h-36 border-2 border-dashed rounded-xl cursor-pointer bg-white/5 border-white/20 hover:bg-white/10 hover:border-gold/50 transition-all group">
                        <div className="flex flex-col items-center justify-center pt-5 pb-6 text-center">
                            <Upload className="w-10 h-10 mb-3 text-primary-foreground/30 group-hover:text-gold transition-colors"/>
                            <p className="mb-2 text-sm font-semibold text-primary-foreground/50 group-hover:text-primary-foreground">Clique para anexar arquivo</p>
                            <p className="text-[10px] text-primary-foreground/40 italic">PDF ou Imagem (Máx 5MB)</p>
                        </div>
                        <Input id="document-upload" name="Anexo" type="file" className="hidden" />
                    </label>
                  </div> 
                </div>

              </div>

              <Button type="submit" disabled={isSubmitting} size="lg" className="w-full btn-gold h-14 text-lg font-bold flex gap-3 shadow-gold/20 hover:scale-[1.02] transition-transform">
                {isSubmitting ? <Loader2 className="w-5 h-5 animate-spin" /> : "Solicitar Atendimento VIP"} <Send className="w-5 h-5" />
              </Button>
            </form>

            <div className="lg:col-span-1 space-y-8">
              {/* Sidebar Info Section (Mantida igual ao anterior para referência visual) */}
              <div className="p-8 rounded-2xl bg-navy-deep/40 backdrop-blur-xl border border-white/10 shadow-xl">
                <h3 className="font-heading text-2xl text-gold mb-6 border-b border-gold/20 pb-2">Por que a JL VIP?</h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-4">
                    <div className="p-2 rounded-lg bg-gold/10 text-gold shrink-0">
                      <Anchor className="w-5 h-5"/>
                    </div>
                    <span className="text-sm text-primary-foreground/80 leading-relaxed uppercase tracking-tighter font-medium">Corpo Técnico especializado e NRs atualizadas.</span>
                  </li>
                  <li className="flex items-start gap-4">
                    <div className="p-2 rounded-lg bg-gold/10 text-gold shrink-0">
                      <Ship className="w-6 h-6"/>
                    </div>
                    <span className="text-sm text-primary-foreground/80 leading-relaxed uppercase tracking-tighter font-medium">Bases Operacionais em Santa Catarina.</span>
                  </li>
                  <li className="flex items-start gap-4">
                    <div className="p-2 rounded-lg bg-gold/10 text-gold shrink-0">
                      <Star className="w-5 h-5"/>
                    </div>
                    <span className="text-sm text-primary-foreground/80 leading-relaxed uppercase tracking-tighter font-medium">Atendimento direto pelos gestores da marca.</span>
                  </li>
                </ul>
              </div>
              
              <div className="p-8 rounded-2xl bg-navy-deep/40 backdrop-blur-xl border border-white/10 shadow-xl">
                <h3 className="font-heading text-2xl text-gold mb-6 border-b border-gold/20 pb-2">Contato Direto</h3>
                <div className="space-y-4">
                  {[
                    { unit: "Balneário Camboriú - SC", phone: "(47) 99233-3200" },
                    { unit: "São Francisco do Sul - SC", phone: "(47) 99269-1561" },
                    { unit: "Barra do Sul - SC", phone: "(47) 99273-0474" },
                    { unit: "Canoinhas - SC", phone: "(47) 99146-8851" },
                  ].map((item, idx) => (
                    <a key={idx} href={`tel:${item.phone.replace(/\D/g, '')}`} className="flex items-center gap-4 p-4 rounded-xl hover:bg-gold/10 transition-all border border-transparent hover:border-gold/20 group">
                      <div className="p-3 rounded-full bg-gold/5 text-gold group-hover:bg-gold group-hover:text-primary transition-all">
                        <Phone className="w-5 h-5"/>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-[10px] text-gold uppercase font-bold tracking-widest">{item.unit}</span>
                        <span className="text-primary-foreground font-semibold">{item.phone}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
      
      <SuccessModal 
        isOpen={showSuccess} 
        onClose={() => setShowSuccess(false)} 
        message="Seu pedido de atendimento VIP foi enviado com sucesso. Nossa equipe entrará em contato em breve."
      />
    </>
  );
};

export default AtendimentoVip;
